import React from 'react';
import Spinner from '../spinner/Spinner';

const Loader = React.memo(() => {
	return <div className="flex items-center justify-center py-16 min-h-[800px]">
		<Spinner width={16} height={16} />
	</div>;
});

export default Loader;